import { MessageSquare, User } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { RatingStars } from '@/components/atoms/RatingStars';

import type { ExternalEvaluationCardProps } from './ExternalEvaluationCard.types';

const sourceIcon = (source: string) =>
	source === 'human' ? <User className="h-sm w-sm" /> : <MessageSquare className="h-sm w-sm" />;

export const ExternalEvaluationCard = ({ verdict }: ExternalEvaluationCardProps) => {
	const { t } = useTranslation('translation', { keyPrefix: 'externalEvaluation' });

	return (
		<article className="flex flex-col gap-xs rounded-md border border-subtle bg-white px-md py-sm">
			<header className="flex items-center justify-between gap-xs">
				<div className="flex items-center gap-2xs text-[12px] font-semibold text-default">
					{sourceIcon(verdict.source)}
					<span>{verdict.judgeName}</span>
					<span className="text-[11px] font-normal text-subtle">· {t(`SOURCE_${verdict.source.toUpperCase()}`)}</span>
				</div>
				{verdict.scale === '1_to_5' ? (
					<RatingStars value={verdict.value} size="md" />
				) : (
					<span className="text-[12px] font-semibold text-default tabular-nums">{verdict.value}</span>
				)}
			</header>
			{verdict.remark ? (
				<p className="text-[12px] leading-5 text-default">&ldquo;{verdict.remark}&rdquo;</p>
			) : (
				<p className="text-[12px] italic text-subtle">{t('NO_REMARK')}</p>
			)}
		</article>
	);
};
